import 'underscore';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
    saveAsDialogOpen: false,
    templatesLimitReachedDialogOpen: false,
    ignoreProperties: []
};

export default createReducer(initialState, {
    SET_SAVE_AS_DIALOG_OPEN: (state, action) => {
        state.saveAsDialogOpen = action.payload;
    },
    SET_TEMPLATES_LIMIT_REACHED_DIALOG_OPEN: (state, action) => {
        state.templatesLimitReachedDialogOpen = action.payload;
    },
    RESET_IGNORE_PROPERTIES: state => {
        state.ignoreProperties = [];
    },
    ADD_IGNORE_PROPERTIES: (state, action) => {
        state.ignoreProperties = _.union(
            state.ignoreProperties,
            action.payload
        );
    },
    REMOVE_IGNORE_PROPERTIES: (state, action) => {
        state.ignoreProperties = _.difference(
            state.ignoreProperties,
            action.payload
        );
    }
});
